export default __webpack_public_path__ + "static/media/match.613b50d0.wav";